import { Component, createRef } from "react"

/* Components */
import { DataLayout, Pagination, Icon, Avatar } from "../../components"

/* Widgets */
import { DetailsModal, CreateModal, QrModal, FilterModal, INITIAL_FILTER } from "../../widgets/organization"

/* Shared */
import { organizationIcon } from "../../widgets/organization/shared"

/* Helpers */
import { withRouter, utils } from "../../helpers"

/* Constants */
import { env } from "../../constants"

/* Moment */
import moment from "moment"
import "moment/locale/ru"

/* REST API */
import { list, remove, status } from "../../api/Organization"

/* Widgets */
import { toast, confirm } from "../../widgets/common"

moment.locale("ru")


/* Page Organizations */
class Organizations extends Component {

    constructor() {
        super()

        this.state = {

            data: [],
            status: "loading",
            count: 0,
            page: 1,
            search: "",
            filter: { ...INITIAL_FILTER }
        }

        /* The card of the point, the form of a new one, the poster and the filters
           are all opened by the reference */
        this._details = createRef()
        this._create = createRef()
        this._qr = createRef()
        this._filter = createRef()
    }

    componentDidMount = () => {

        this.load()

        /* Another tab sends here with ?open=ID — the card of that point opens at once */
        const { location, navigate } = this.props
        const id = parseInt(new URLSearchParams(location ? location.search : "").get("open"))

        if (id) {
            this.open({ id })
            navigate("/organization", { replace: true })
        }
    }

    /* Load action */
    load = (page = 1, reload = false) => {

        /* Fields */
        const { search, filter } = this.state

        /* Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        this.setState({ page })

        /* Set to REST API */
        list({ page, search, ...filter }).then(response => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data.list, count: response.data.count })
            }
            else {
                this.setState({ status: "error", data: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [], count: 0 })
        })
    }

    /* On Submit */
    search = event => {
        event.preventDefault()
        this.load(1)
    }

    /* Search Action */
    searchText = text => {
        if (text === "") {
            this.setState({ search: text }, () => this.load(1))
        }
        else {
            this.setState({ search: text })
        }
    }

    /* How many values of the filter differ from the empty one — the button shows the number */
    filters = () => {

        /* Fields */
        const { filter } = this.state

        return Object.keys(INITIAL_FILTER).filter(key => `${filter[key]}` !== `${INITIAL_FILTER[key]}`).length
    }

    /* Change visible — the card of the point waits for the answer to redraw itself */
    change = item => {

        const { data } = this.state
        const value = parseInt(item.visible) === 1 ? 0 : 1

        return status({ id: item.id, value }).then(response => {

            if (response.status === 200) {

                const index = data.findIndex(element => parseInt(element.id) === parseInt(item.id))

                if (index > -1) {
                    data[index].visible = value
                    this.setState({ data })
                }

                toast.success(value === 1 ? "Организация включена" : "Организация отключена")
            }
            else {
                toast.error("Что-то пошло не так! Попробуйте позднее")
            }
        }).catch(() => {
            toast.error("Что-то пошло не так! Попробуйте позднее")
        })
    }

    /* Remove organization */
    remove = item => {

        confirm({
            title: "Вы действительно хотите удалить?",
            text: "Невозможно восстановить после удаления",
            confirmText: "Да, удалить!",
            cancelText: "Нет",
            danger: true
        }).then(confirmed => {

            if (!confirmed) {
                return
            }

            remove({ id: item.id }).then(response => {

                if (response.status === 200) {

                    if (this._details.current) {
                        this._details.current.close()
                    }

                    this.load(this.state.page, true)

                    toast.success("Успешно удалено")
                }
                else {
                    toast.error("Что-то пошло не так! Попробуйте позднее")
                }
            }).catch(() => {
                toast.error("Что-то пошло не так! Попробуйте позднее")
            })
        })
    }

    /* Open the card of the point */
    open = item => {
        this._details.current.open(item)
    }

    /* Draw one point of the table */
    _item = (item, index) => {

        const image = item.image ? `${env.mediapoint}organizations/${item.image}` : null
        const subscribed = item.subscribedUntil && moment(item.subscribedUntil).isAfter(moment())
        const days = item.subscribedUntil ? moment(item.subscribedUntil).diff(moment(), "days") : null

        return (
            <div onClick={() => this.open(item)} className="organization-item" key={`${index}`}>

                <div className="organization-item-cell name">

                    <Avatar className="organization-item-avatar" src={image} alt={item.name}>
                        {organizationIcon()}
                    </Avatar>

                    <div className="organization-item-title">
                        <div className="organization-item-name">
                            {utils.check(item.name, "-")}
                            {item.serviceMode === "QUEUE_BASED" && <div className="organization-item-badge">Очередь</div>}
                        </div>
                        <div className="organization-item-url">{item.city ? item.city : "Город не выбран"}</div>
                    </div>

                </div>

                <div className="organization-item-cell address">
                    <div className="organization-item-value">{utils.check(item.address, "Адрес не указан")}</div>
                </div>

                <div className="organization-item-cell phone">
                    <div className="organization-item-value">{utils.check(item.phone, "-")}</div>
                </div>

                <div className="organization-item-cell subscription">
                    {subscribed
                        ? <div className="organization-item-pill green">
                            <span>до {moment(item.subscribedUntil).format("DD.MM.YY")}</span>
                            <em>{days > 0 ? `${days} дн.` : "последний день"}</em>
                        </div>
                        : <div className="organization-item-pill red">
                            <span>Не оплачена</span>
                            <em>{item.subscribedUntil ? `истекла ${moment(item.subscribedUntil).format("DD.MM.YY")}` : "оплаты не было"}</em>
                        </div>
                    }
                </div>

                <div className="organization-item-cell state">
                    <div className={`organization-item-state ${parseInt(item.visible) === 1 ? "on" : "off"}`}>
                        <i />
                        {parseInt(item.visible) === 1 ? "Включен" : "Отключен"}
                    </div>
                </div>

                <div className="organization-item-cell arrow">
                    <Icon name="right" size={15} width={2} />
                </div>

            </div>
        )
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { status, data, count, page } = this.state

        /* Layout */
        if (status !== "ok" || data.length === 0) {
            return (
                <div className="page-content">
                    <DataLayout status={status} reload={() => this.load(1, true)} data={data} onReset={() => this.setState({ search: "", filter: { ...INITIAL_FILTER } }, () => this.load(1, true))} />
                </div>
            )
        }

        return (
            <div className="page-content">

                <div className="organization-list">

                    <div className="organization-item head">
                        <div className="organization-item-cell name">Организация</div>
                        <div className="organization-item-cell address">Адрес</div>
                        <div className="organization-item-cell phone">Телефон</div>
                        <div className="organization-item-cell subscription">Подписка</div>
                        <div className="organization-item-cell state">Статус</div>
                        <div className="organization-item-cell arrow" />
                    </div>

                    {data.map((item, index) => this._item(item, index))}

                </div>

                <Pagination size={10} page={page} total={count} onPageChange={page => this.load(page, true)} />

            </div>
        )
    }

    /* Draw Header */
    _header = () => {

        /* Fields */
        const { search, filter } = this.state

        const active = this.filters()

        return (
            <div className="organization-header">

                <div className="page-header-text">Организации</div>

                <div className="organization-header-tools">

                    <form onSubmit={this.search} className="organization-search">

                        <div className="organization-search-icon">
                            <Icon name="search" size={17} />
                        </div>

                        <input placeholder="Название, телефон, адрес" value={search} onChange={event => this.searchText(event.target.value)} />

                        {search.length > 0 &&
                            <div onClick={() => this.searchText("")} className="organization-search-clear">
                                <Icon name="close" size={11} width={2.4} />
                            </div>
                        }

                    </form>

                    <div onClick={() => this._filter.current.open(filter)} title="Фильтр" className={`organization-filter-button ${active > 0 ? "active" : ""}`}>
                        <Icon name="filter" size={19} />
                        {active > 0 && <div className="organization-filter-count">{active}</div>}
                    </div>

                    <div onClick={() => this._create.current.open()} className="organization-create">
                        <Icon name="plus" size={17} width={2.4} />
                        <span>Создать</span>
                    </div>

                </div>

            </div>
        )
    }

    render = () => {

        return (
            <div className="page">

                {/* Draw Header */}
                {this._header()}

                {/* Draw Content */}
                {this._content()}

                {/* Draw Details */}
                <DetailsModal
                    ref={this._details}
                    onQr={item => this._qr.current.open(item)}
                    onStatus={item => this.change(item)}
                    onRemove={item => this.remove(item)}
                    onChanged={() => this.load(this.state.page)}
                />

                {/* Draw Create */}
                <CreateModal ref={this._create} onCreated={() => this.load(1, true)} />

                {/* Draw QR */}
                <QrModal ref={this._qr} />

                {/* Draw Filters */}
                <FilterModal ref={this._filter} onApply={filter => this.setState({ filter }, () => this.load(1, true))} />

            </div>
        )
    }
}

export default withRouter(Organizations)
